import React, { Component } from "react";
import { connect } from "react-redux";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import swal from "sweetalert";
import moment from "moment-timezone";
import SimpleReactValidator from "simple-react-validator";
import service from "../services";
import Loader from "../component/loader";
import TextField from "../component/TextField";
import TextEditor from "../component/TextEditor";
import EditIcon from "../icons/EditIcon";
import PlusIcon from "../icons/plusicon";
import delet from "../assets/images/delet.svg";
import commonImage from "../commonImage";
import Select from "react-select";
import DeletefileIcon from "../icons/DeletefileIcon";
import ReactPaginate from "react-paginate";
import serachIcon from "../assets/images/search.svg";

const RECORDS_PER_PAGE = 10;

const BLANK_RECORD = {
  image: "",
  imageUrl: "",
  openImageInNewTab: true,
  year: "",
  yearUrl: "",
  openYearInNewTab: true,
  title: "",
  titleUrl: "",
  openTitleInNewTab: true,
};

let sub;

class ArchivesPage extends Component {
  constructor(props) {
    super(props);
    this.apiserve = new service();
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.recordValidator = new SimpleReactValidator({ autoForceUpdate: this });
    this.sponsorUpload = React.createRef();
    this.recordUpload = React.createRef();
    this.state = {
      // view state
      showForm: false,
      loaderFlag: false,
      searchText: "",
      // main form fields
      updateId: "",
      pageTitle: "",
      description: EditorState.createEmpty(),
      sponsorTitle: "",
      sponsorImage: "",
      records: [],
      isActive: true,
      // record modal
      recordModal: false,
      recordEditIndex: null,
      tempRecord: { ...BLANK_RECORD },
      recordInitial: null,
      recordDeleteMode: false,
      recordPage: 0,
      // sponsor modal
      sponsorModal: false,
      sponsorInitial: null,
      // image upload
      sponsorImagePreview: "",
      sponsorImagePreloader: false,
      recordImagePreview: "",
      recordImagePreloader: false,
      // updated by
      lastUpdatedAt: "",
      lastUpdatedBy: null,
    };
  }

  componentDidMount() {
    this.setupSubscription();
    this.fetchPage();
  }

  componentWillUnmount() {
    if (sub) {
      sub.unsubscribe();
    }
  }

  setupSubscription() {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "archivesPage|getArchivesPage":
          this.setState({ loaderFlag: false });
          if (!response.error && response.data) {
            this.openEditForm(response.data[0]);
          } else {
            this.openAddForm();
          }
          break;
        case "archivesPage|updateArchivesPage":
          if (response.error) {
            this.apiserve.error(response.data && response.data.error);
            this.setState({ loaderFlag: false, recordDeleteMode: false });
          } else {
            const msg = this.state.recordDeleteMode
              ? "Deleted successfully."
              : "Saved successfully.";
            this.setState({ recordDeleteMode: false }, () => {
              this.apiserve.success(msg);
              this.fetchPage();
            });
          }
          break;
        default:
          break;
      }
    });
  }

  fetchPage() {
    this.setState({ loaderFlag: true });
    this.apiserve.sendevent("archivesPage|getArchivesPage", {
      isActive: true,
      sort: "order",
    });
  }

  openAddForm() {
    this.validator.hideMessages();
    this.recordValidator.hideMessages();
    this.setState({
      showForm: true,
      updateId: "",
      pageTitle: "",
      description: EditorState.createEmpty(),
      sponsorTitle: "",
      sponsorImage: "",
      sponsorImagePreview: "",
      records: [],
      isActive: true,
      lastUpdatedAt: "",
      lastUpdatedBy: null,
    });
  }

  openEditForm(item) {
    this.validator.hideMessages();
    this.recordValidator.hideMessages();
    this.setState({
      showForm: true,
      updateId: item._id,
      pageTitle: item.pageTitle || "",
      description: this.getHtmlToEditor(item.description || ""),
      sponsorTitle: (item.sponsor && item.sponsor.title) || "",
      sponsorImage: (item.sponsor && item.sponsor.image) || "",
      sponsorImagePreview: (item.sponsor && item.sponsor.image) || "",
      records: item.records
        ? item.records.map((r) => ({ ...BLANK_RECORD, ...r }))
        : [],
      isActive: item.isActive !== undefined ? item.isActive : true,
      lastUpdatedAt: item.updatedAt || "",
      lastUpdatedBy: item.updatedBy || null,
    });
  }

  openSponsorModal() {
    const { pageTitle, description, sponsorTitle, sponsorImage } = this.state;
    this.setState({
      sponsorModal: true,
      sponsorInitial: {
        pageTitle,
        description: draftToHtml(convertToRaw(description.getCurrentContent())),
        sponsorTitle,
        sponsorImage,
      },
    });
  }

  closeSponsorModal() {
    this.setState({ sponsorModal: false, sponsorInitial: null });
  }

  saveSponsorModal() {
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      return;
    }
    this.setState({ sponsorModal: false }, () => {
      this.savePageToBackend();
    });
  }

  // ── Record modal ───────────────────────────────────────────────

  openRecordModal(index) {
    this.recordValidator.hideMessages();
    const initial = index !== null ? { ...this.state.records[index] } : { ...BLANK_RECORD };
    this.setState({
      recordModal: true,
      recordEditIndex: index,
      tempRecord: { ...initial },
      recordInitial: { ...initial },
      recordImagePreview:
        index !== null ? (this.state.records[index].image || "") : "",
    });
  }

  closeRecordModal() {
    this.recordValidator.hideMessages();
    this.setState({
      recordModal: false,
      recordEditIndex: null,
      tempRecord: { ...BLANK_RECORD },
      recordInitial: null,
      recordImagePreview: "",
    });
  }

  updateTempRecord(field, value) {
    this.setState((prevState) => ({
      tempRecord: { ...prevState.tempRecord, [field]: value },
    }));
  }

  saveRecord() {
    if (!this.recordValidator.allValid()) {
      this.recordValidator.showMessages();
      return;
    }
    const { records, recordEditIndex, tempRecord } = this.state;
    let updatedRecords;
    if (recordEditIndex === null) {
      updatedRecords = [...records, { ...tempRecord }];
    } else {
      updatedRecords = [...records];
      updatedRecords[recordEditIndex] = { ...tempRecord };
    }
    this.setState({ records: updatedRecords, recordPage: 0 }, () => {
      this.savePageToBackend(updatedRecords);
      this.closeRecordModal();
    });
  }

  savePageToBackend(records) {
    const descHtml = draftToHtml(
      convertToRaw(this.state.description.getCurrentContent())
    );
    const mappedRecords = (records || this.state.records).map((r) => ({
      ...r,
      year: parseInt(r.year, 10),
      openImageInNewTab: Boolean(r.openImageInNewTab),
      openYearInNewTab: Boolean(r.openYearInNewTab),
      openTitleInNewTab: Boolean(r.openTitleInNewTab),
    }));

    const payload = {
      pageTitle: this.state.pageTitle,
      description: descHtml,
      sponsor: {
        title: this.state.sponsorTitle,
        image: this.state.sponsorImage,
      },
      records: mappedRecords,
      isActive: this.state.isActive,
    };

    payload.pageId = this.state.updateId;

    this.setState({ loaderFlag: true });
    this.apiserve.sendevent("archivesPage|updateArchivesPage", payload);
  }

  deleteRecordConfirm(index) {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const records = [...this.state.records];
        records.splice(index, 1);
        this.setState({ records, recordDeleteMode: true, recordPage: 0 }, () => {
          this.savePageToBackend(records);
        });
      }
    });
  }

  // ── Image upload ───────────────────────────────────────────────

  deleteSponsorImage() {
    this.setState({ sponsorImage: "", sponsorImagePreview: "" });
  }

  deleteRecordImage() {
    this.updateTempRecord("image", "");
    this.setState({ recordImagePreview: "" });
  }

  handleSponsorImageUpload(e) {
    e.stopPropagation();
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      const sizeKb = Math.round(file.size / 1024);
      if (sizeKb >= 5120) {
        this.apiserve.error("Please upload a file smaller than 5 MB");
        return;
      }
      if (!["image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
        this.apiserve.error("Please upload a PNG, JPG or JPEG file");
        return;
      }
      this.setState({ sponsorImagePreloader: true, sponsorImagePreview: event.target.result });
      var fileSet = commonImage(file, false, "", event.target.result);
      fileSet.then((value) => {
        this.setState({ sponsorImage: value || "", sponsorImagePreloader: false });
      });
    };
  }

  handleRecordImageUpload(e) {
    e.stopPropagation();
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      const sizeKb = Math.round(file.size / 1024);
      if (sizeKb >= 5120) {
        this.apiserve.error("Please upload a file smaller than 5 MB");
        return;
      }
      if (!["image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
        this.apiserve.error("Please upload a PNG, JPG or JPEG file");
        return;
      }
      this.setState({ recordImagePreloader: true, recordImagePreview: event.target.result });
      var fileSet = commonImage(file, false, "", event.target.result);
      fileSet.then((value) => {
        this.updateTempRecord("image", value || "");
        this.setState({ recordImagePreloader: false });
      });
    };
  }

  // ── Other handlers ─────────────────────────────────────────────

  onInputChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onEditorStateChange(description) {
    this.setState({ description });
  }

  getHtmlToEditor(html) {
    if (!html) return EditorState.createEmpty();
    const { contentBlocks, entityMap } = htmlToDraft(html);
    if (contentBlocks) {
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  }

  // ── Form view ──────────────────────────────────────────────────

  renderFormView() {
    const {
      updateId,
      loaderFlag,
      records,
      lastUpdatedAt,
      lastUpdatedBy,
      recordPage,
      searchText,
    } = this.state;

    const sortedRecords = [...records].sort((a, b) => parseInt(b.year, 10) - parseInt(a.year, 10));
    const filteredRecords = searchText.trim()
      ? sortedRecords.filter((r) => {
          const q = searchText.trim().toLowerCase();
          return (
            String(r.year || "").toLowerCase().includes(q) ||
            (r.title || "").toLowerCase().includes(q)
          );
        })
      : sortedRecords;
    const pageCount = Math.ceil(filteredRecords.length / RECORDS_PER_PAGE);
    const pagedRecords = filteredRecords.slice(
      recordPage * RECORDS_PER_PAGE,
      (recordPage + 1) * RECORDS_PER_PAGE
    );

    return (
      <div className="right_side_wrapper">
        {/* Records section header with Add Record + Edit Sponsor buttons */}
        <div className="dashboard_header with_btn pl_15">
          <div className="searchBlock">
            <span>Archives Page</span>
            <div className="search_box" style={{ display: "inline-flex", alignItems: "center", marginLeft: "20px" }}>
              <form onSubmit={e => { e.preventDefault(); }}>
              <input
                type="text"
                placeholder="Search by year or title..."
                value={searchText}
                onChange={(e) => this.setState({ searchText: e.target.value, recordPage: 0 })}
                className="search_input"
              />
              <button type='button' style={{ pointerEvents: 'none' }}>
                <img src={serachIcon} />
              </button>
              </form>
            </div>
          </div>
          <div className="button_block admin_user_twoBtn" style={{ display: "flex", gap: "10px" }}>
            <button
              type="button"
              className="head_btn pointer no_border"
              onClick={() => this.openSponsorModal()}
              style={{ minWidth: "140px" }}
            >
              Edit Page
            </button>
            <button
              type="button"
              className="head_btn pointer no_border"
              onClick={() => this.openRecordModal(null)}
              style={{ minWidth: "140px" }}
            >
              <PlusIcon /> &nbsp; Add Record
            </button>
          </div>
        </div>
        {/* Last updated by — right-aligned row below header */}
        {updateId && lastUpdatedAt && (
          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt pl_15 pr_15">
            <span></span>
            <p className="update_date">
              Last Update: {moment.tz(lastUpdatedAt, "US/Mountain").format("h")}:{moment.tz(lastUpdatedAt, "US/Mountain").format("mm")} {moment.tz(lastUpdatedAt, "US/Mountain").format("A")} - {moment.tz(lastUpdatedAt, "US/Mountain").format("MM/DD/YYYY")} &nbsp; Last Updated By: {(lastUpdatedBy && lastUpdatedBy.fname) || ""} {(lastUpdatedBy && lastUpdatedBy.lname) || ""}
            </p>
          </div>
        )}
        <div className="category_add_edit">
          <div className="table_wrap product_list_tbl film_list_table striped_table">
            <table>
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Year</th>
                  <th>Title</th>
                  <th>Image URL</th>
                  <th>Year URL</th>
                  <th>Title URL</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredRecords.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text_center">
                      {records.length === 0 ? "No records added yet." : "No records match your search."}
                    </td>
                  </tr>
                )}
                {pagedRecords.map((rec, pageIndex) => {
                  const filteredIndex = recordPage * RECORDS_PER_PAGE + pageIndex;
                  const realIndex = records.indexOf(filteredRecords[filteredIndex]);
                  return (
                    <tr key={realIndex}>
                      <td>
                        {rec.image ? (
                          <img
                            src={this.apiserve.imageUrl + rec.image}
                            alt="record"
                            style={{ height: "50px", width: "50px", objectFit: "cover" }}
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>{rec.year || "-"}</td>
                      <td>{rec.title || "-"}</td>
                      <td>
                        {rec.imageUrl ? (
                          <span className="display_name">{rec.imageUrl}</span>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        {rec.yearUrl ? (
                          <span className="display_name">{rec.yearUrl}</span>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        {rec.titleUrl ? (
                          <span className="display_name">{rec.titleUrl}</span>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        <div className="action_wrap d_flex d_flex_align_center" style={{gap: "8px"}}>
                          <span
                            className="cat_edit pointer"
                            onClick={() => this.openRecordModal(realIndex)}
                          >
                            <EditIcon />
                          </span>
                          <span
                            className="remove_cat pointer"
                            onClick={() => this.deleteRecordConfirm(realIndex)}
                          >
                            <img src={delet} alt="delete" />
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {pageCount > 1 && (
          <div className="custom-pagination pagination_mb">
            <ReactPaginate
              previousLabel={""}
              nextLabel={""}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={({ selected }) => this.setState({ recordPage: selected })}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              forcePage={recordPage}
            />
          </div>
        )}

        {/* Record add/edit modal */}
        {this.renderRecordModal()}

        {/* Sponsor modal */}
        {this.renderSponsorModal()}
      </div>
    );
  }

  // ── Record popup modal ─────────────────────────────────────────

  renderRecordModal() {
    const {
      recordModal,
      recordEditIndex,
      tempRecord,
      recordInitial,
      recordImagePreview,
      loaderFlag,
    } = this.state;

    const recordChanged = recordEditIndex === null
      ? true
      : recordInitial
        ? JSON.stringify(tempRecord) !== JSON.stringify(recordInitial)
        : false;

    return (
      <div className={`user_popup archives_record_popup ${recordModal ? "active" : ""}`}>
        <span
          className="popup_overlay"
          onClick={() => this.closeRecordModal()}
        ></span>
        <div className="cat_modal_inner" style={{ maxWidth: "530px" }}>
          <p className="cat_title text_center">
            {recordEditIndex === null ? "Add Record" : "Edit Record"}
          </p>
          <form>

            {/* Image upload */}
            <div className="field_row horizontal_field small_file_upload">
              <div className="field_row_inner">
                <label>Image</label>
                <div className="field_input relative">
                  <div className="media_image mb_0 absolute_loader relative">
                    {this.state.recordImagePreloader ? (
                      <Loader />
                    ) : (
                      <img
                        src={
                          recordImagePreview && recordImagePreview.startsWith('data:')
                            ? recordImagePreview
                            : tempRecord.image
                              ? this.apiserve.imageUrl + tempRecord.image
                              : "/images/image-placeholder2.png"
                        }
                        alt="record"
                      />
                    )}
                    <div className={`input_file add_input_file ${tempRecord.image ? "active" : ""}`}>
                      <input
                        type="file"
                        ref={this.recordUpload}
                        style={{ display: "none" }}
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => this.handleRecordImageUpload(e)}
                      />
                      <span onClick={() => this.recordUpload.current.click()}>
                        <PlusIcon />
                      </span>
                    </div>
                    {tempRecord.image && (
                      <span
                        className="remove_file remove_input_file pointer"
                        onClick={() => this.deleteRecordImage()}
                      >
                        <DeletefileIcon />
                      </span>
                    )}
                  </div>
                  <span className="error">
                    {this.recordValidator.message(
                      "record_image",
                      tempRecord.image,
                      "required"
                    )}
                  </span>
                </div>
              </div>
            </div>

            <div className="field_row horizontal_field d_flex">
              <TextField
                type="text"
                label="Image Link URL"
                value={tempRecord.imageUrl}
                onChange={(e) =>
                  this.updateTempRecord("imageUrl", e.target.value)
                }
              />
            </div>

            <div className="field_row horizontal_field d_flex" style={{ alignItems: "center", gap: "8px" }}>
              <label htmlFor="tempOpenImageInNewTab" style={{ margin: 0 }}>Open Image in New Tab</label>
              <input
                type="checkbox"
                id="tempOpenImageInNewTab"
                name="tempOpenImageInNewTab"
                checked={tempRecord.openImageInNewTab}
                onChange={(e) =>
                  this.updateTempRecord("openImageInNewTab", e.target.checked)
                }
              />
            </div>

            <div className="field_row horizontal_field d_flex">
              <div className="field_row_inner">
                <label>Year</label>
                <div className="field_input">
                  <Select
                    placeholder="Select Year"
                    options={Array.from(
                      { length: new Date().getFullYear() - 1985 + 1 },
                      (_, i) => {
                        const yr = new Date().getFullYear() - i;
                        return { value: yr, label: String(yr) };
                      }
                    )}
                    value={
                      tempRecord.year
                        ? { value: tempRecord.year, label: String(tempRecord.year) }
                        : null
                    }
                    onChange={(selected) =>
                      this.updateTempRecord("year", selected ? selected.value : "")
                    }
                  />
                  <span className="error">
                    {this.recordValidator.message(
                      "record_year",
                      tempRecord.year,
                      "required"
                    )}
                  </span>
                </div>
              </div>
            </div>

            <div className="field_row horizontal_field d_flex">
              <TextField
                type="text"
                label="Year URL"
                value={tempRecord.yearUrl}
                onChange={(e) =>
                  this.updateTempRecord("yearUrl", e.target.value)
                }
              />
            </div>

            <div className="field_row horizontal_field d_flex" style={{ alignItems: "center", gap: "8px" }}>
              <label htmlFor="tempOpenYearInNewTab" style={{ margin: 0 }}>Open Year in New Tab</label>
              <input
                type="checkbox"
                id="tempOpenYearInNewTab"
                name="tempOpenYearInNewTab"
                checked={tempRecord.openYearInNewTab}
                onChange={(e) =>
                  this.updateTempRecord("openYearInNewTab", e.target.checked)
                }
              />
            </div>

            <div className="field_row horizontal_field d_flex">
              <TextField
                type="text"
                label="Title"
                value={tempRecord.title}
                onChange={(e) =>
                  this.updateTempRecord("title", e.target.value)
                }
              />
            </div>

            <div className="field_row horizontal_field d_flex">
              <TextField
                type="text"
                label="Title URL"
                value={tempRecord.titleUrl}
                onChange={(e) =>
                  this.updateTempRecord("titleUrl", e.target.value)
                }
              />
            </div>

            <div className="field_row horizontal_field d_flex" style={{ alignItems: "center", gap: "8px" }}>
              <label htmlFor="tempOpenTitleInNewTab" style={{ margin: 0 }}>Open Title in New Tab</label>
              <input
                type="checkbox"
                id="tempOpenTitleInNewTab"
                name="tempOpenTitleInNewTab"
                checked={tempRecord.openTitleInNewTab}
                onChange={(e) =>
                  this.updateTempRecord("openTitleInNewTab", e.target.checked)
                }
              />
            </div>

            <div className="cat_btns text_center">
              <button
                type="button"
                onClick={() => this.closeRecordModal()}
              >
                CANCEL
              </button>
              <button
                type="button"
                disabled={loaderFlag || !recordChanged}
                className={loaderFlag || !recordChanged ? "" : "active"}
                onClick={() => this.saveRecord()}
              >
                SAVE
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  // ── Sponsor popup modal ────────────────────────────────────────

  renderSponsorModal() {
    const {
      sponsorModal,
      pageTitle,
      description,
      sponsorTitle,
      sponsorImage,
      sponsorImagePreview,
      sponsorInitial,
      loaderFlag,
    } = this.state;

    const sponsorChanged = sponsorInitial
      ? pageTitle !== sponsorInitial.pageTitle ||
        sponsorTitle !== sponsorInitial.sponsorTitle ||
        sponsorImage !== sponsorInitial.sponsorImage ||
        draftToHtml(convertToRaw(description.getCurrentContent())) !== sponsorInitial.description
      : false;

    return (
      <div className={`user_popup archives_record_popup ${sponsorModal ? "active" : ""}`}>
        <span
          className="popup_overlay"
          onClick={() => this.closeSponsorModal()}
        ></span>
        <div className="cat_modal_inner" style={{ maxWidth: "530px" }}>
          <p className="cat_title text_center">Edit Sponsor</p>
          <form>

            <div className="field_row horizontal_field">
              <TextField
                type="text"
                label="Page Title"
                name="pageTitle"
                value={pageTitle}
                onChange={(e) => this.onInputChange(e)}
                fpgerror={this.validator.message("pageTitle", pageTitle, "required")}
              />
            </div>

            <div className="field_row horizontal_field">
              <div className="field_row_inner">
                <label>Description</label>
                <div className="field_input relative editor_wrapper">
                  <TextEditor
                    name="description"
                    editorState={description}
                    value={description}
                    onEditorStateChange={(val) => this.onEditorStateChange(val)}
                  />
                </div>
              </div>
            </div>

            <div className="field_row horizontal_field">
              <TextField
                type="text"
                label="Sponsor Title"
                name="sponsorTitle"
                value={sponsorTitle}
                onChange={(e) => this.onInputChange(e)}
              />
            </div>

            {/* Sponsor Image upload */}
            <div className="field_row horizontal_field small_file_upload">
              <div className="field_row_inner">
                <label>Sponsor Image</label>
                <div className="field_input relative">
                  <div className="media_image mb_0 absolute_loader relative">
                    {this.state.sponsorImagePreloader ? (
                      <Loader />
                    ) : (
                      <img
                        src={
                          sponsorImagePreview && sponsorImagePreview.startsWith('data:')
                            ? sponsorImagePreview
                            : sponsorImage
                              ? this.apiserve.imageUrl + sponsorImage
                              : "/images/image-placeholder2.png"
                        }
                        alt="sponsor"
                      />
                    )}
                    <div className={`input_file add_input_file ${sponsorImage ? "active" : ""}`}>
                      <input
                        type="file"
                        ref={this.sponsorUpload}
                        style={{ display: "none" }}
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => this.handleSponsorImageUpload(e)}
                      />
                      <span onClick={() => this.sponsorUpload.current.click()}>
                        <PlusIcon />
                      </span>
                    </div>
                    {sponsorImage && (
                      <span
                        className="remove_file remove_input_file pointer"
                        onClick={() => this.deleteSponsorImage()}
                      >
                        <DeletefileIcon />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="cat_btns text_center">
              <button
                type="button"
                onClick={() => this.closeSponsorModal()}
              >
                CANCEL
              </button>
              <button
                type="button"
                disabled={loaderFlag || !sponsorChanged}
                className={loaderFlag || !sponsorChanged ? "" : "active"}
                onClick={() => this.saveSponsorModal()}
              >
                SAVE
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  render() {
    const { showForm, loaderFlag } = this.state;
    return (
      <React.Fragment>
        {showForm && this.renderFormView()}
        {loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  profileName: state.profileName,
});

export default connect(mapStateToProps)(ArchivesPage);
